import { useTranslation } from 'react-i18next';
import { useFeatureFlagsContext } from 'src/providers/FeatureFlagsProvider/FeatureFlags.context';
import { useModalsContext } from '../../../../../../../../../providers/ModalsProvider/Modals.context.ts';
import { eChannelType } from '../../../../../../../../../providers/SocketsProvider/Sockets.enums.ts';
import { useUserContext } from '../../../../../../../../../providers/UserProvider/User.context.ts';
import { useChatContext } from '../../../../../../../Chat.hook.ts';
import { integrationBubbleTitleKey } from '../MessageBubbleV2.functions.ts';

/**
 * Who an outgoing bubble names as its sender: Lead Agent, a bot, "Tú", the
 * team member who sent it, or the channel when it came from the phone. Shared
 * by the message bubble and the album bubble (INT-1227).
 */
export default function useSenderTitle(createdBy: string) {
  const { t } = useTranslation('chat/chat');
  const { isSmartLeadBotEnabled } = useFeatureFlagsContext();
  const { currentUser } = useUserContext();
  const { selectedChat } = useChatContext();
  const { selectedLeadForChatModal } = useModalsContext();

  const isLeadAgent = isSmartLeadBotEnabled && createdBy === 'smart_leadbot';
  const isCurrentUser = createdBy === currentUser?.authId;

  const namedTitle =
    (isLeadAgent && 'Lead Agent') ||
    (createdBy === 'leadbot' && 'Leadbot') ||
    (createdBy === 'Follow Up' && 'Leadsales') ||
    (isCurrentUser && t('messageBubble.you')) ||
    (createdBy &&
      selectedChat?.lead?.users?.find((user) => user.auth_id === createdBy)
        ?.name);
  const channel =
    selectedLeadForChatModal?.chat?.integration || eChannelType.WHATSAPP_WEB;
  const title = namedTitle || t(integrationBubbleTitleKey[channel]);
  // Nobody in Leadsales sent it: on WhatsApp that means the phone (or WhatsApp
  // Web), which the label says as "WhatsApp Web o celular" with a phone icon.
  const isPhone =
    !namedTitle &&
    (channel === eChannelType.WHATSAPP_API || channel === eChannelType.WHATSAPP_WEB);

  return { title, isLeadAgent, isPhone };
}
